<template>
  <div>
    <h1>Joining a group</h1>
    <div>Everything you need to know</div>
  </div>
</template>